import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { CompanyAPIService } from 'app/api/company.api.service';
import { AppState } from 'app/reducers';
import { parseErrorMessage } from 'app/utils/callstate';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom, mergeMap } from 'rxjs/operators';

import { CompanyActions } from '../actions';
import { CompaniesUISelectors } from '../selectors';

@Injectable()
export class CompanyEffects {
  loadCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyActions.companyRequested),
      withLatestFrom(
        this.store.select(CompaniesUISelectors.selectCurrentCompanyId)
      ),
      switchMap(([_, companyId]) =>
        this.companyApiService.Company(companyId).pipe(
          map((company) => CompanyActions.companyLoaded({ company })),
          catchError((error) =>
            of(
              CompanyActions.companyCancelled({
                errorMessage: parseErrorMessage(error),
              })
            )
          )
        )
      )
    )
  );

  // deleteCompany$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(CompanyActions.companyDeleteRequested),
  //     mergeMap(({ input }) =>
  //       this.companyApiService.DeleteCompanyData(input).pipe(
  //         map((entry) => CompanyActions.companyDeleteSuccess({ entry })),
  //         catchError((error) =>
  //           of(
  //             CompanyActions.companyDeleteError({
  //               errorMessage: parseErrorMessage(error),
  //             })
  //           )
  //         )
  //       )
  //     )
  //   )
  // );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private companyApiService: CompanyAPIService
  ) {}
}
